import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import Userbanner from '../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync } from '../../../components/helper/axiosHelper';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const Points = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apidata, setApidata] = useState([]);
  const [total, setTotal] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [sortOrderAmount, setSortOrderAmount] = useState('asc'); // Ascending order by default for Amount
  const [sortOrderDonor, setSortOrderDonor] = useState('asc'); // Ascending order by default for Number Of Donor

  const {pathname} = useLocation();

  const getpointdata = async () => {
    setIsLoad(true);
    await getAsync(`ServiceForYou/ServiceForYouPointList/`, { id: epUserID }).then((resp) => {
      setIsLoad(false);
      setApidata(resp?.data[0]?.items);
      setTotal(resp?.data[0]);
      if (resp?.statusCode === 204) {
        setDatanotfound(true);
      }
    });
  };

  const toggleSortOrderAmount = () => {
    const newSortOrder = sortOrderAmount === 'asc' ? 'desc' : 'asc';
    const sortedData = [...apidata].sort((a, b) => {
      return newSortOrder === 'asc' ? a.amount - b.amount : b.amount - a.amount;
    });
    setSortOrderAmount(newSortOrder);
    setApidata(sortedData);
  };

  const toggleSortOrderDonor = () => {
    const newSortOrder = sortOrderDonor === 'asc' ? 'desc' : 'asc';
    const sortedData = [...apidata].sort((a, b) => {
      return newSortOrder === 'asc' ? a.numberOfDonor - b.numberOfDonor : b.numberOfDonor - a.numberOfDonor;
    });
    setSortOrderDonor(newSortOrder);
    setApidata(sortedData);
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      getpointdata();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  return (
    <>
      <div className="pt-12 py-5 lg:py-10">
        <Userbanner />
        {isLoad ? (
          // <LoadingAnimation />
          <LoadingAnimation
            imageStyling={''}
            styling={'flex items-center py-10 align-middle justify-center space-x-2'}
          />
        ) : (
          <div className="container-fluid container-fluid ">
            <h1 className="text-center text-customgreen text-3xl font-bold pt-4">{t('Service For You Points')}</h1>

            <div className="row justify-center py-5 lg:py-10">
              <div className="col-xl-11 ">
                <div className="overflow-x-auto grid-cols-subgrid col-span-6 col-start-2 bg-white">
                  <table className="min-w-full text-left text-sm whitespace-nowrap">
                    <thead className="uppercase bg-customgreen ">
                      <tr className="text-sm font-light text-white">
                        <th scope="col" className="px-6 py-2 w-6  text-center font-medium">
                          {t('sNo')}
                        </th>
                        <th scope="col" className="px-6 py-2  text-center font-medium">
                          {t('Project Name')}
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-2 text-center font-medium cursor-pointer"
                          onClick={toggleSortOrderDonor}
                        >
                          {t('Number Of Donor')}
                          <span className="ml-2">
                            {sortOrderDonor === 'asc' ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                          </span>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-2 cursor-pointer  text-center font-medium"
                          onClick={toggleSortOrderAmount}
                        >
                          {t('Amount')}
                          <span className="ml-2">
                            {sortOrderAmount === 'asc' ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {apidata?.map((data, index) => (
                        <tr key={index} className="border-b dark:border-neutral-600">
                          <th scope="row" className="px-6 py-4 font-normal">
                            {index + 1}
                          </th>
                          <td className="px-6 py-4 text-center">{data?.projectNameAR}</td>
                          <td className="px-6 py-4 text-center">{data?.numberOfDonor}</td>
                          <td className="px-6 py-4 text-center">{data?.amount}</td>
                        </tr>
                      ))}
                      <tr>
                        <td className={`px-2 py-2 ${isActive ? 'text-left' : 'text-right'} font-bold`} colSpan="2">
                          {t('Total')}:
                        </td>
                        <td className="border text-center font-bold">{total?.totalDonor || 0}</td>
                        <td className="border text-center font-bold">{total?.totalAmount || 0}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
        {datanotfound && <DataNotFound />}
      </div>
    </>
  );
};

export default Points;
